<template>
    <tiptap-editor
        class="note-pane-quill-instance"
        v-model="content"
        @ready="editorReady"
        @input="$emit('input', content)"
        :disabled="isBusy"
        :paragraphs-on-return="paragraphsOnReturn">
    </tiptap-editor>
</template>

<style lang="scss">
    .note-pane-quill-instance {
        position: relative;
        font-size: 16px;
        margin-top: 20px;

        nav {
            border: none;
            margin-bottom: -55px;
        }
    }
</style>

<script>
    import { NoteResource  } from '../../classes/Api/Note'
    import TiptapEditor from '../../../ts/Tiptap/Editor.vue'

    export default {
        components: { TiptapEditor },
        props: {
            value: {
                type: String,
                default: ''
            },
            isBusy: {
                type: Boolean,
                default: false
            },
            paragraphsOnReturn: {
                type: Boolean,
                default: false
            },
            owners: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                content: '',
            }
        },
        created() {
            this.content = this.value
        },
        methods: {
            editorReady(editor) {
                this.$nextTick(() => {
                    editor.chain().focus('start').run()
                })
            },
            reset() {
                this.content = ''
            },
            save() {
                return new Promise((resolve, reject) => {
                    this.$emit('saving')

                    let owners = this.owners.map(item => {
                        return item.type + ':' + item.id
                    })

                    NoteResource.store({ content: this.content, owners }).then(response => {
                        this.$emit('saved', response.data)
                        this.reset()
                        resolve(response.data)
                    }).catch(e => {
                        handleApiError(e, reject)
                        this.$emit('error', e)
                    })
                })
            },
        },
        watch: {
            value(n, o) {
                if (n !== o) {
                    this.content = n
                }
            }
        }
    }
</script>